import * as React from "react";

function SvgPlanhat(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 250 134"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g fill="#263238" fillRule="evenodd">
        <ellipse
          transform="rotate(180 120 99.75)"
          cx={120}
          cy={99.75}
          rx={120}
          ry={33.25}
        />
        <path d="M118.245 0s-10.823.175-22.532 4.51C84.004 8.842 77.34 14.496 72.84 18.61c-2.894 2.645-6.765 6.94-10.048 11.79-3.283 4.851-4.38 7.517-5.94 11.072C53.022 50.195 52 60.802 52 60.802h135.983s-1.243-10.583-6.195-21.73c-4.952-11.146-9.739-16.104-14.576-20.462-4.919-4.432-13.758-10.614-22.613-13.794-1.42-.51-2.82-1.07-4.596-1.61-1.776-.542-4.484-1.215-6.473-1.62a70.881 70.881 0 00-5.192-.831C126.411.523 120.216 0 120.216 0h-1.97z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgPlanhat);
